import { useCallback, useState } from 'react';
import { setIsImageUploadDrawerOpen, useAppContext } from '../../../../context/app-context';
import { useActiveCanvas } from '../../../../hooks/use-active-canvas';
import { ReplaceImageProps } from '../../image-edit-drawer/image-edit-drawer-types';

type UseReplaceImageFlow = {
  isReplaceConfirmationOpen: boolean;
  openReplaceConfirmation: () => void;
  closeReplaceConfirmation: () => void;
  confirmReplaceImage: () => void;
};

/**
 * Encapsulates the "replace image" confirmation flow used by the desktop
 * toolbar so the toolbar component itself stays focused on layout.
 */
export const useReplaceImageFlow = (): UseReplaceImageFlow => {
  const { appDispatch } = useAppContext();
  const canvas = useActiveCanvas();
  const [isOpen, setIsOpen] = useState(false);

  const openReplaceConfirmation = useCallback(() => setIsOpen(true), []);
  const closeReplaceConfirmation = useCallback(() => setIsOpen(false), []);

  const confirmReplaceImage = useCallback(() => {
    const activeObject = canvas?.current?.getActiveObject();
    if (activeObject) {
      (activeObject as ReplaceImageProps).isReplacingUserImage = true;
    }
    setIsImageUploadDrawerOpen(appDispatch);
    setIsOpen(false);
  }, [appDispatch, canvas]);

  return {
    isReplaceConfirmationOpen: isOpen,
    openReplaceConfirmation,
    closeReplaceConfirmation,
    confirmReplaceImage,
  };
};
